import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "M15.5 3H5a2 2 0 0 0-2 2v14c0 1.1.9 2 2 2h14a2 2 0 0 0 2-2V8.5L15.5 3Z",
            stroke: `${color}`
          }
        ),
        /* @__PURE__ */ jsx(Path, { d: "M15 3v6h6", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M10 16s.8 1 2 1c1.3 0 2-1 2-1", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M8 13h0", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M16 13h0", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Sticker";
const Sticker = memo(themed(Icon));
export {
  Sticker
};
//# sourceMappingURL=sticker.js.map
